import axios from '@axios'

export default {
    namespaced: true,
    actions: {
        fetchGeofences(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios.get('maps/get_geofence', { params: queryParams })
                    .then(response => resolve(response)).catch(error => reject(error))
            })
        },

        getFilterBy(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios.get('filters/getFilterBy', {params: queryParams})
                  .then(response => resolve(response))
                  .catch(error => reject(error))
            })
        },
    },
}
